import { Server } from '../../server/server';
import { UIDialog } from '../common/ui/uiDialog';
import { UIImage } from '../common/ui/uiImage';
import { UIPanel } from '../common/ui/uiPanel';
import { UIPanelButton } from '../common/ui/uiPanelButton';
import { UIText } from '../common/ui/uiText';
import { GameStyle } from './gameStyle';

export enum PowerUpType {
  DoubleScore,
  Shields,
  SlowMotion
}

export const PowerupImage = new Map([
  [PowerUpType.DoubleScore, require('./assets/button-score.png')],
  [PowerUpType.Shields,     require('./assets/button-shields.png')],
  [PowerUpType.SlowMotion,  require('./assets/button-slow.png')],
]);

export const PowerupName = new Map([
  [PowerUpType.DoubleScore, 'Double Score'],
  [PowerUpType.Shields,     'Shields'],
  [PowerUpType.SlowMotion,  'Slow Motion'],
]);

export class PupListDialog extends UIDialog {

  popup: UIPanel;
  pup_1: UIPanelButton;
  pup_2: UIPanelButton;
  pup_3: UIPanelButton;
  pup_1_amt: UIText;
  pup_2_amt: UIText;
  pup_3_amt: UIText;
  titleText: UIText;
  slotNumber: number;
  instructionsText: UIText;

  public setSlotNumber(n:number) {
    this.slotNumber = n;
  }

  public build() {

    let size_x = 290;

    this.popup = new UIPanel({
      size: {x: size_x, y: 270},
      anchor: {x: 0.5, y: 0.45},
      pivot: {x: 0.5, y: 0.5},
      position: {x: 0, y: 0},
      radius: this.options.panel.radius,
      color: this.options.panel.color,
      gradient: this.options.panel.gradient,
      borderColor: this.options.panel.borderColor,
      borderWidth: this.options.panel.borderWidth,
      shadow: this.options.panel.shadow,
      parent: this
    });

    this.titleText = new UIText({
      text: 'INVENTORY',
      position: {x: 0, y: 15},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: this.options.title.color,
      fontFamily: this.options.title.fontFamily,
      fontSize: this.options.title.fontSize,
      fontWeight: this.options.title.fontWeight,
      shadow: this.options.title.shadow,
      parent: this.popup
    });

    this.instructionsText = new UIText({
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      text: 'Select a powerup to go into this slot:',
      position: {x: 0, y: 45},
      horizontalAlign: 'center',
      color: '#ffffff80',
      fontFamily: this.options.message.fontFamily,
      fontSize: this.options.message.fontSize,
      parent: this.popup
    });

    let props  = this.setPowerupProps(PowerUpType.DoubleScore, 20);
    this.pup_1 = new UIPanelButton(props);

    props      = this.setPowerupProps(PowerUpType.Shields, 110);
    this.pup_2 = new UIPanelButton(props);

    props      = this.setPowerupProps(PowerUpType.SlowMotion, 200);
    this.pup_3 = new UIPanelButton(props);

    this.buildPowerup(this.pup_1, PowerUpType.DoubleScore, 20);
    this.buildPowerup(this.pup_2, PowerUpType.Shields, 110);
    this.buildPowerup(this.pup_3, PowerUpType.SlowMotion, 200);

    let backButton = new UIPanelButton({
      text : 'Back',
      anchor : {x : 0.5, y : 1},
      pivot : {x : 0.5, y : 1},
      position : {x : 0, y : -20},
      size : {x : 130, y : 40},
      callback : () => {
        this.hide();
        this.callback(-1);
      },
      panelColors: this.options.button.panelColors,
      textColors: this.options.button.textColors,
      radius: this.options.button.radius,
      fontFamily: this.options.button.fontFamily,
      fontSize: this.options.button.fontSize,
      textOffset: this.options.button.textOffset,
      borderColor: this.options.button.borderColor,
      borderWidth: this.options.button.borderWidth,
      parent : this.popup
    });
  }

  public onWake() {
    // this.titleText.text = 'SLOT ' + this.slotNumber.toString();
    this.instructionsText.text = 'Select a powerup for Slot ' + this.slotNumber.toString() + ':';

    // get power ups amount available
    this.pup_1_amt.text = Server.user.getAssetQuantity('whacka-double-score').toString();
    this.pup_2_amt.text = Server.user.getAssetQuantity('whacka-shields').toString();
    this.pup_3_amt.text = Server.user.getAssetQuantity('whacka-slow-motion').toString();

    let slot_1 = localStorage.getItem('whacka-slot-1');
    let slot_2 = localStorage.getItem('whacka-slot-2');
    let slot_3 = localStorage.getItem('whacka-slot-3');

    this.updateSlotText(slot_1);
    this.updateSlotText(slot_2);
    this.updateSlotText(slot_3);

    this.disableSlot(this.pup_1_amt, this.pup_1);
    this.disableSlot(this.pup_2_amt, this.pup_2);
    this.disableSlot(this.pup_3_amt, this.pup_3);
  }

  protected disableSlot(amtText: UIText, slot: UIPanelButton) {
    if (amtText.text == '0') {
      slot.disabled = true;
      // slot.setDisabledColors('#00000020', '#00000020');
    }
    else {
      slot.disabled = false;
    }
  }

  protected updateSlotText(slot: string) {
    if (slot == PowerUpType.DoubleScore.toString())
      this.pup_1_amt.text = String(Number(this.pup_1_amt.text) - 1);

    if (slot == PowerUpType.Shields.toString())
      this.pup_2_amt.text = String(Number(this.pup_2_amt.text) - 1);

    if (slot == PowerUpType.SlowMotion.toString())
      this.pup_3_amt.text = String(Number(this.pup_3_amt.text) - 1);
  }

  protected buildPowerup(powerup: UIPanelButton, powerupType: number, x: number) {
    let img_props = this.setImageProps(powerupType, powerup);
    let pup_image = new UIImage(img_props);
    
    let amt_props = this.setAmountTextProps(powerup);

    if (powerupType == PowerUpType.DoubleScore)
      this.pup_1_amt = new UIText(amt_props);
    else if (powerupType == PowerUpType.Shields)
      this.pup_2_amt = new UIText(amt_props);
    else if (powerupType == PowerUpType.SlowMotion)
      this.pup_3_amt = new UIText(amt_props);

    let pupText = new UIText({
      anchor: {x: 0.5, y: 1},
      pivot: {x: 0.5, y: 0},
      text: PowerupName.get(powerupType),
      position: {x: 0, y: 5},
      color: '#ffffff80',
      horizontalAlign: 'center',
      fontFamily: GameStyle.fonts.small.family,
      fontSize: GameStyle.fonts.small.size-2,
      parent: powerup
    });
  }

  protected setPowerupProps(powerupType: number, x: number) {
    let data = {
      panelColors : {normal : '#00000080'},
      radius : 10,
      borderWidth : 2,
      borderColor : '#000000',
      textColors : {normal : '#ffffff'},
      callback : () => {
        this.hide();
        this.callback(powerupType);
      },
      anchor : {x : 0, y : 0},
      pivot : {x : 0, y : 0},
      size : {x : 70, y : 70},
      position : {x : x, y : 105},
      parent : this.popup
    };

    return data;
  }

  protected setImageProps(powerupType: number, parent: UIPanelButton) {
    let data = {
      url : PowerupImage.get(powerupType),
      anchor : {x : 0.5, y : 0.5},
      pivot : {x : 0.5, y : 0.5},
      position : {x : 0, y : 0},
      size : {x : 60, y : 60},
      stretch : true,
      parent : parent
    };

    return data;
  }

  protected setAmountTextProps(parent: UIPanelButton) {
    let data = {
      text : '0',
      color : '#ffffff',
      fontFamily : 'impact',
      fontSize : 18,
      anchor : {x : 0.5, y : 0},
      pivot : {x : 0.5, y : 0},
      position : {x : 0, y : -30},
      // strokeLineWidth : 2,
      // shadow: {
      //   color: '#000000',
      //   blur: 2,
      //   offset: {
      //     x: 4,
      //     y: 4
      //   }
      // },
      parent : parent
    };

    return data;
  }
}